module.exports = __webpack_public_path__ + "img/Park N Parcel.52d36517.png";